<template>
  <router-link href="javascript:alert(this);" class="chatZoneLink" :to="item.routeLink" :rel="item.rel" @click="clickHandler">
        <div class="chatZoneMenuItemTitle">
          <p class="channel-title">{{item.zoneName}}</p>
          <p>{{item.userCount > 0  ? item.userCount.toLocaleString() : ""}}</p>
          <p class="active-bar"></p>
        </div>
  </router-link>
</template>

<script>
export default {
  props: [
    'item'
  ],
  methods: {
    clickHandler () {
    }
  }
}
</script>

<style lang="scss">

.chatZoneLink {
  text-align: center;
  color: #000;
  height: 100%;
  padding: 21px 8px;
  display: block;
  float: left;
  box-sizing: border-box;
  position: relative;

  &:hover .chatZoneMenuItemTitle{ color: #ed2026}

  .chatZoneMenuItemTitle p { margin: 0px; }
  .chatZoneMenuItemTitle {


      .channel-title {
        font-size: 12px;
        margin-bottom: 2px;
      }
    }

  &.router-link-active .chatZoneMenuItemTitle {
    color: #ed2026;
  }

  &.router-link-active .active-bar {
    border-bottom: 3px solid #ed2026;
    position: absolute;
    bottom: 0;
    left:0;
    width: 100%;
  }

}
</style>



// WEBPACK FOOTER //
// chat-zone-menu-item.vue?3298d620